<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-row>
          
            <v-col cols="3" class="text-xs-right">
      <v-btn color="#7BC243" to="/estatecuredbroker" class="white--text cataloguebtn">View All Estate Cured </v-btn>
    </v-col>
            <v-spacer></v-spacer>
          </v-row>
          <v-card-title>
            <v-row>
              <v-col cols="4" md="4">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search By Outturn"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="8" class="text-right">
                <h4>{{ records[0]?.documentUpload?.fileName }}</h4>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <!--            <v-progress-circular-->
            <!--              v-if="loading"-->
            <!--              indeterminate-->
            <!--              color="primary"-->
            <!--            ></v-progress-circular>-->

            <v-data-table
              :loading="loading"
              v-model="selected"
              :headers="computedHeaders"
              :items="records"
              item-key="id"
              show-select
              class="elevation-1"
              :search="search"
              :single-select="singleSelect"
            >
             

              <template
  v-slot:top
  v-if="records && hasCanBeApprovedData(records) && $can('CAN_APPROVE_ESTATE_CURED_BROKER')"
>
  <v-btn class="mr-2" @click="confirmAction('APPROVE_SELECTED')" color="primary">
    Approve Selected
  </v-btn>

  <v-btn
    v-if="canRejectRecords()"
    class="ml-2"
    @click="confirmAction('REJECT_SELECTED')"
    color="warning"
  >
    Reject Selected
  </v-btn>

  <v-btn class="ml-2" @click="confirmAction('APPROVE_ALL')" color="success">
    Approve All
  </v-btn>

  <v-btn
    v-if="canRejectRecords()"
    class="ml-2"
    @click="confirmAction('REJECT_ALL')"
    color="warning"
  >
    Reject All
  </v-btn>
</template>

<template v-slot:[`item.data-table-select`]="{ isSelected, select, item }">
  <v-simple-checkbox
    :ripple="false"
    color="green"
    :value="isSelected"
    @input="select($event)"
    v-if="canShowCheckbox(item, currentUserRole) && $can('CAN_APPROVE_ESTATE_CURED_BROKER')"
  ></v-simple-checkbox>
</template>



              



              <template v-slot:[`item.actions`]="{ item }">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      v-on="on"
                      text
                      icon
                      class="actions"
                    >
                      <v-icon class="secondary--text"> more_horiz</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-if="
                        ($can('CAN_UPLOAD_CATALOGUE') )
                    
                      "
                      
                      @click="showEditDialog(item, 'edit')"
                    >
                      <v-list-item-title> Edit</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      v-if="
                        ($can('CAN_UPLOAD_GRN') &&
                          hasGrnApproveMillerData(item)) ||
                        ($can('CAN_APPROVE_GRN') &&
                          hasGrnApproveWarehouseData(item))
                      "
                      @click="showEditDialog(item, 'approve')"
                    >
                      <v-list-item-title> Approve</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="confirmDialog" max-width="400">
      <v-card>
        <v-card-title
          class="body-2 primary--text font-weight-bold text-capitalize"
          >Catalogue Records
        </v-card-title>
        <v-card-text class="primary--text">
          {{ confirmMessage }}
          <v-text-field
            name="comment"
            label="Comment"
            v-model="approverComment"
            :rules="commentRules"
            required
          >
          </v-text-field>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="confirmDialog = false"
            class="font-weight-bold"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            class="accent--text logoutbtn"
            @click="approveRecords()"
          >
            Confirm
          </v-btn>
          <v-progress-linear v-if="showProgressBar" indeterminate height="14" width="16"></v-progress-linear>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline accent--text"
          >{{ action }} Catalogue Record</v-card-title
        >
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="grnRecord.outturn"
                  label="OutTurn"
                  v-bind:readonly="approve"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="grnRecord.numberOfBags"
                  label="Bags"
                  required
                  v-bind:readonly="approve"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="grnRecord.numberOfPocket"
                  label="Pockets"
                  required
                  v-bind:readonly="approve"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="grnRecord.splitNumber"
                  label="Split Number"
                  required
                  v-bind:readonly="approve"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="grnRecord.lotNumber"
                  label="Lot Number"
                  required
                  v-bind:readonly="approve"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="grnRecord.weight"
                  label="Gross W"
                  required
                  v-bind:readonly="approve"
                >
                </v-text-field>
              </v-col>
             
             
            </v-row>
            <!--            <v-flex xs12 sm6 md6>-->
            <!--              <v-checkbox-->
            <!--                v-bind:readonly="approve"-->
            <!--                v-model="grnRecord.deleteFlag"-->
            <!--                label="Delete"-->
            <!--                @change="handleChange"-->
            <!--              ></v-checkbox>-->
            <!--            </v-flex>-->
          </v-form>
        </v-card-text>

        <v-card-actions v-if="approve">
          <v-btn
            color="white"
            class="accentd--text"
            style="font-weight: 700"
            @click="editDialog = false"
            >Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="triggerApproveRecord">Approve</v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-btn
            color="white"
            class="accentd--text"
            style="font-weight: 700"
            @click="editDialog = false"
            >Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="triggerEditRecord">Edit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from 'axios'
import config from '../../../config'

export default {
  name: "estatecuredbrokerfiledetails",
  data: function () {
    return {
      headers: [
        { text: "LotNumber", value: "lot" },
        { text: "GrowerCode", value: "growerCode" },
        { text: "GrowerOutturn", value: "growerOutturn" },
        { text: "CuredOutturn", value: "curedOutturn" },
        { text: "BrokerOutturn", value: "brokerOutturn" },
        { text: "Marks", value: "mark" },
        { text: "Grade", value: "grade" },
        { text: "Bags", value: "bags" },
        { text: "Pockets", value: "pockets" },
        { text: "CleanNetWeight", value: "cleanNetWeight" },
        { text: "SplitNumber", value: "splitNumber" },
        { text: "SaleNo", value: "saleNumber" },
        { text: "CropSeason", value: "cropSeason" },     
        { text: "SplitNumber", value: "splitNumber" },     
        { text: "BrokerCode", value: "brokerCode" },
        { text: "Warehouse", value: "warehouseCode" },
        { text: "TransportCharge", value: "transportCharge" },
        { text: "DryingCharge", value: "dryingCharge" },
        { text: "HandSortingCharge", value: "handSortingCharge" },
        { text: "DeliveryDate", value: "deliveryDate" },
        { text: "Actions", value: "actions" },
      ],
      selected: [],
      recordsToApprove: [],
      search: "",
      singleSelect: false,
      grnRecord: {},
      editDialog: false,
      approve: false,
      valid: true,
      action: "",
      confirmDialog: false,
      confirmMessage: "",
      commentRules: [(v) => !!v || "Comment is required"],
      approverComment: "",
      record_count: 0,
      userID:0,
      showProgressBar:false
    };
  },
  watch: {},
  computed: {
    ...mapState({
      loading: (state) => state.estatecuredbrokerfile.loading,
      records: (state) => state.estatecuredbrokerfile.records,
      user: (state) => state.user ,
    }),
  
shouldShowCheckbox() {
    return this.$can('CAN_APPROVE_ESTATE_CURED_BROKER');
  },
    computedHeaders() {
      // Check if the status column should be added
      const showStatus = this.hasGrnStatus().length > 0;
      const headers = [...this.headers];

      if (showStatus) {
        // Insert the status header at the desired position
        headers.splice(13, 0, { text: "Status", value: "status.statusName" });
      }

      return headers;
    },
    currentUserRole: function() {
      console.log("Current user",this.user.roleId.name)
    return this.user?.roleId?.name || "";
  },
    userId: function () {
      if (this.user) {
        this.organisationType = this.user.organisation.organisationType.name;
        this.organisationId = this.user.organisation.id;
        this.userID = this.user.id;
        this.username = this.user.username;
        // this.currentUserRole=this.user.roleId.name
        return this.user.id;
      }
      return 0;
    }
 
  },
  methods: {
    // getCatalogueDetails () {
		// 	const url = config.serverURI + '/upload/estatecured/' + this.$route.params.id + '/data'
		// 	console.log(url)
		// 	axios.get(url)
		// 		.then(response => {
		// 			this.items = response.data
		// 		})
		// 		.catch(error => {
		// 			console.log('error', error.response)
		// 		})
		// 	return this.items
		// },
    handleChange() {
      // Update deleteFlag to true if the checkbox is checked
      this.grnRecord.deleteFlag = true;
    },

    confirmAction(action) {
    console.log('Action>>>>>>>>>', action);
    this.action = action;
    this.confirmDialog = true;
    this.recordsToApprove = this.action.includes("SELECTED")
        ? this.selected.filter(
            (record) =>
              record.status &&
              (record.status.id === 3 || record.status.id === 100|| record.status.id === 102|| record.status.id === 103|| record.status.id === 104|| record.status.id === 105|| record.status.id === 106|| record.status.id === 23)
            //   record?.requireReapproval === "N"
          )
        : this.records.filter(
            (record) =>
              record.status &&
              (record.status.id === 3 || record.status.id === 100|| record.status.id === 102|| record.status.id === 103|| record.status.id === 104|| record.status.id === 105|| record.status.id === 106|| record.status.id === 23)
            //   record?.requireReapproval === "N"
          );
    this.confirmMessage =
        action + " - " + this.recordsToApprove.length + " records";
},

    hasGrnStatusIdData(item) {
      // Assuming item.status is the property containing status data
      // return this.records.filter(item => item.status !== null );
      return (
        item.status &&
        (item.status.statusName === "HOLDING_STATUS" ||
          item.status.statusName === "PENDING_WAREHOUSE_APPROVAL" ||
          item.status.statusName === "PENDING_APPROVAL")
      );
      // return this.records.filter(item => item.status !== null);
    },

    hasGrnApproveWarehouseData(item) {
      // Assuming item.status is the property containing status data
      // return this.records.filter(item => item.status !== null );
      return (
        item.status && item.status.statusName === "PENDING_WAREHOUSE_APPROVAL"
      );
    },

    hasGrnApproveMillerData(item) {
      // Assuming item.status is the property containing status data
      // return this.records.filter(item => item.status !== null );
      return item.status && item.status.statusName === "REFERRED_TO_MILLER";
      // return this.records.filter(item => item.status !== null);
    },
    canRejectRecords() {

      return this.$can('CAN_APPROVE_ESTATE_CURED_BROKER');
      // Assuming item.status is the property containing status data
      // return this.records.filter(item => item.status !== null );
      // return (this.user.roleId.name==='MARKETER_CHECKER')
      // return this.records.filter(item => item.status !== null);
    },
  //   canShowCheckbox(record, currentUserRole) {
  //   if (!record.status || !record.status.statusName) return false;

  //   const status = record.status.statusName;

  //   if (status === "PENDING_APPROVAL") {
  //     return currentUserRole === "MARKETER_CHECKER" || currentUserRole === "WAREHOUSE_CHECKER";
  //   }

  //   if (status === "PENDING_WAREHOUSE_APPROVAL") {
  //     return currentUserRole === "WAREHOUSE_CHECKER";
  //   }

  //   if (status === "PENDING_BROKER_APPROVAL") {
  //     return currentUserRole === "MARKETER_CHECKER";
  //   }

  //   return false;
  // },


  canShowCheckbox(record, currentUserRole) {
  if (!record.status || !record.status.statusName) return false;

  const status = record.status.statusName;

  const rolePermissions = {
    PENDING_APPROVAL: ["MARKETER_CHECKER", "WAREHOUSE_CHECKER","WAREHOUSE","BROKER_CHECKER"],
    PENDING_WHMAKER_AND_BRCHECKER_APPROVAL: ["WAREHOUSE_MAKER","MARKETER_CHECKER", "BROKER_CHECKER","WAREHOUSE"],
    PENDING_WHCHECKER_AND_BRCHECKER_APPROVAL: ["WAREHOUSE_CHECKER","MARKETER_CHECKER", "BROKER_CHECKER"],
    PENDING_WHCHECKER_APPROVAL: ["WAREHOUSE_CHECKER"],
    PENDING_BRCHECKER_APPROVAL: ["MARKETER_CHECKER", "BROKER_CHECKER"],
    PENDING_WHMAKER_APPROVAL: ["WAREHOUSE","WAREHOUSE_MAKER"],
    PENDING_WAREHOUSE_APPROVAL: ["WAREHOUSE","WAREHOUSE_CHECKER","WAREHOUSE_MAKER"]
  };
  const result = rolePermissions[status]?.includes(currentUserRole) ?? false;
  console.log("Checkbox check:", { status, currentUserRole, result });
  return result;
  
},

// PENDING_APPROVAL: ["MARKETER_CHECKER", "WAREHOUSE_CHECKER","WAREHOUSE"],
//     PENDING_WHMAKER_AND_BRCHECKER_APPROVAL: ["WAREHOUSE_MAKER","MARKETER_CHECKER"],
//     PENDING_WHCHECKER_AND_BRCHECKER_APPROVAL: ["WAREHOUSE_CHECKER","MARKETER_CHECKER"],
//     PENDING_WHCHECKER_APPROVAL: ["WAREHOUSE_CHECKER"],
//     PENDING_BRCHECKER_APPROVAL: ["MARKETER_CHECKER"],
//     PENDING_WHMAKER_APPROVAL: ["WAREHOUSE"],
//     PENDING_WAREHOUSE_APPROVAL: ["WAREHOUSE","WAREHOUSE_CHECKER"]
    hasCanBeApprovedData(records) {
      return (
        records.length > 0 &&
        records.some(
          (record) =>
            record.status && (record.status.statusName === "PENDING_APPROVAL"||record.status.statusName === "PENDING_WHMAKER_AND_BRCHECKER_APPROVAL"||record.status.statusName === "PENDING_WHCHECKER_AND_BRCHECKER_APPROVAL"||record.status.statusName === "PENDING_WHCHECKER_AND_BRCHECKER_APPROVAL"||record.status.statusName === "PENDING_WHCHECKER_APPROVAL"||record.status.statusName === "PENDING_BRCHECKER_APPROVAL"||record.status.statusName === "PENDING_WHMAKER_APPROVAL"||record.status.statusName === "PENDING_WAREHOUSE_APPROVAL")
        )
      );
    },
    hasCanBeApprovedByWarehouse(records) {
      return (
        records.length > 0 &&
        records.some(
          (record) =>
            record.status && record.status.statusName === "PENDING_WAREHOUSE_APPROVAL"
        )
      );
    },

    hasGrnStatus() {
      // Assuming item.status is the property containing status data
      // return this.records.filter(item => item.status !== null );
      return this.records.filter((item) => item.status !== null);
    },
    ...mapActions({
      warehouseApproveRecords2: "estatecuredbrokerfile/warehouseApproveRecords2",
      warehouseApproveRecords: "estatecuredbrokerfile/warehouseApproveRecords",
      editRecord: "estatecuredbrokerfile/editRecord",
      millerApproveRecord: "estatecuredbrokerfile/millerApproveRecord",
    }),
    showEditDialog(item, type) {
      console.log("Item>>>>",item)
      this.grnRecord = item;
      this.editDialog = true;
      this.action = type;
      if (type !== "edit") {
        this.approve = true;
      }
    },
    approveRecords() {
      if (this.recordsToApprove.length === 0) {
        this.$store.dispatch("alert/displayAlert", {
          snackbar: true,
          color: "error",
          message: "No record selected for action " + this.action,
        });
      } else {
        const recordData = {
          action: this.action,
          comment: this.approverComment,
          records: this.recordsToApprove,
        };
        this.warehouseApproveRecords2(recordData)
          .then((response) => {
            if (response.data.error === false) {
              this.$store.dispatch("alert/displayAlert", {
                snackbar: true,
                color: 'primary',
                message: response.data.message,
              });
            } else {
              this.$store.dispatch("alert/displayAlert", {
                snackbar: true,
                color: "error",
                message: response.data.message,
              });
            }
            this.$store.dispatch("estatecuredbrokerfile/viewFile", this.$route.params.id);
            this.selected = [];
            this.confirmDialog = false;
            this.recordsToApprove = [];
            this.approverComment = "";
            this.confirmMessage = "";
          })
          .catch((error) => {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: "error",
              message: error.response.data
                ? error.response.data.message
                : "Error ocurred",
            });
          });
      }
    },
    triggerEditRecord() {
      this.editRecord(this.grnRecord)
        .then((response) => {
          if (response.data.error === false) {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: 'primary',
              message: response.data.message,
            });
          } else {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: "error",
              message: response.data.message,
            });
          }
          this.$store.dispatch("estatecuredbrokerfile/viewFile", this.$route.params.id);
          this.selected = [];
          this.editDialog = false;
        })
        .catch((error) => {
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: error.response.data
              ? error.response.data.message
              : "Error ocurred",
          });
          this.editDialog = false;
        });
    },
    triggerApproveRecord() {
      // this.millerApproveRecord(this.grnRecord).then(response => {
      this.editRecord(this.grnRecord)
        .then((response) => {
          if (response.data.error === false) {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: 'primary',
              message: response.data.message,
            });
          } else {
            this.$store.dispatch("alert/displayAlert", {
              snackbar: true,
              color: "error",
              message: response.data.message,
            });
          }
          this.$store.dispatch("estatecuredbrokerfile/viewFile", this.$route.params.id);
          this.selected = [];
          this.editDialog = false;
        })
        .catch((error) => {
          this.$store.dispatch("alert/displayAlert", {
            snackbar: true,
            color: "error",
            message: error.response.data
              ? error.response.data.message
              : "Error ocurred",
          });
          this.editDialog = false;
        });
    },
  },
//   mounted () {
// 		this.getCatalogueDetails()
// 		this.documentId = this.$route.params.id
// 		this.permissions = store.state.user.roleId.permissions
// 	},
  created() {
    this.$store.dispatch("estatecuredbrokerfile/resetestatecuredbrokerfiles");
    this.$store.dispatch("estatecuredbrokerfile/viewFile", this.$route.params.id);
    // this.getCatalogueDetails(); // Calling getCatalogueDetails() instead of viewFile
    // console.log(this.$store.dispatch('estatecuredbrokerfile/viewFile', this.$route.params.id))
  },

};
</script>
<style></style>
